import React, {useState} from "react";
import {
    Input,
    Button,
    Tooltip,
    Table,
    DatePicker,
    Select,
    Popconfirm,
    Pagination
} from "antd";

import locale from 'antd/es/date-picker/locale/zh_CN';

import {SearchOutlined, ToTopOutlined} from '@ant-design/icons';

import Refund from "./com/refund";//退款
import Remark from "../../components/Remark";//备注
import PrintPro from "../../components/ExportOrder/printPro";/////批量导出订单

import UserInfo from "../../components/UserInfo";

import './index.sass'
import {Link} from "react-router-dom";
import api from "../../utils/api";
import qs from "../../utils/qs";
import {Base64} from 'js-base64';
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect, shallowEqual} from "react-redux";
import OrderType from "../../utils/OrderType";
import {isEmpty} from 'lodash';
import OrderStatus from "../../utils/OrderStatus";
import {CustomDefineExporter} from '../../components/ExportOrder/ExporterBoard';
import SystemType from "../../utils/SystemType";
import {AddOnceCustomOrderExportTaskEvent} from "../../events/AddCustomOrderExportTaskEvent";
import EventDispatcher from "../../events";
import moment from "moment";
import {searchConditionConstructor} from "../../utils/functions";

const {RangePicker} = DatePicker;
const OrderStatusOptions = [
    {
        title: '全部',
        value: OrderStatus.ALL,
    }, {
        title: '待支付',
        value: [OrderStatus.ORDER_WAIT_PAY],
    }, {
        title: '已支付，待发货',
        value: [OrderStatus.ORDER_WAIT_SEND],
    }, {
        title: '待自提，待收货',
        value: [OrderStatus.ORDER_WAIT_RECEIVE],
    }, {
        title: '已收货',
        value: [OrderStatus.ORDER_SUCCESS],
    }, {
        title: "已完成",
        value: [OrderStatus.ORDER_COMPLETE],
    }, {
        title: "取消订单(未支付)",
        value: [OrderStatus.ORDER_WAIT_PAY_CANCELED]
    }, {
        title: "取消订单(已支付)",
        value: [OrderStatus.ORDER_WAIT_SEND_CANCELED],
    }, {
        title: "退款中",
        value: [OrderStatus.ORDER_WAIT_REFUND],
    }, {
        title: "退款审核中",
        value: [OrderStatus.ORDER_WAIT_PAY_CANCEL],
    }
];

const Tabs = (props) => {
    let {orderType, changeOrderType} = props;
    const [tabs] = useState([{
        title: '所有订单',
        value: OrderType.ALL_ORDERS,
    }, {
        title: '我的帮买订单（合约订单）',
        value: OrderType.CONTRACT_PRODUCT_ORDERS,
    }, {
        title: '我的团购订单',
        value: OrderType.SELF_SALE_PRODUCT_ORDER,
    }, {
        title: '我的商城订单',
        value: OrderType.ONLINE_MALL_ORDERS,
    }, {
        title: '扫码付订单',
        value: OrderType.OFFLINE_PAYMENT_ORDERS,
    }]);
    return (
        <div className='tabBox contentItemWrapper'>
            <ul className='flex tabs'>
                {
                    tabs.map((tab, index) => {
                        return (
                            <li className={orderType === tab['value'] ? 'active' : ''} key={index} onClick={() => {
                                changeOrderType(tab['value']);
                            }}>
                                {tab['title']}
                            </li>)
                    })
                }
            </ul>
        </div>
    );
};
const HeaderRight = (props) => {
    const {statisticsData} = props;
    return (<ul className='flex census'>
        <li>
            <label>进行中的团购</label>
            <p>{statisticsData['gb_num']}</p>
        </li>
        <li>
            <label>进行中的合约</label>
            <p>{statisticsData['contract_num']}</p>
        </li>
        <li>
            <label>今日总销售额</label>
            <p>￥{statisticsData['total_amount']}</p>
        </li>
    </ul>);
};
const SearchBox = (props) => {
    const SelectOrderStatusStyle = {"width": "160px"};
    const {searchCondition, setSearchCondition, searchCall} = props;

    return (<div className='searchBox contentItemWrapper flex'>
        <div className='flex line alignCenter mgr20 searchBoxItem'>
            搜索团购名称：
            <Input placeholder='团购名称' value={searchCondition.contractName} onChange={(e) => {
                searchCondition.contractName = e.target.value;
                setSearchCondition(searchCondition);
            }}/>
        </div>

        <div className='flex line alignCenter mgr20 searchBoxItem'>
            搜索用户/商户：
            <Input placeholder='搜索用户/商户' value={searchCondition.mchOrUserName} onChange={(e) => {
                searchCondition.mchOrUserName = e.target.value;
                setSearchCondition(searchCondition);
            }}/>
        </div>
        <div className='flex line alignCenter mgr20 searchBoxItem'>
            订单状态：
            <Select
                placeholder="全部"
                optionFilterProp="children"
                style={SelectOrderStatusStyle}
                value={searchCondition.orderStatus}
                onChange={(value) => {
                    searchCondition.orderStatus = value;
                    setSearchCondition(searchCondition);
                }}>
                {
                    OrderStatusOptions.map((option, i) => {
                        return <option key={i} value={i} label={option.title}>{option.title}</option>
                    })
                }
            </Select>
        </div>

        <div className='flex line alignCenter mgr20 searchBoxItem'>
            订单编号：
            <Input placeholder='订单编号' value={searchCondition.orderId} onChange={(e) => {
                searchCondition.orderId = e.target.value;
                setSearchCondition(searchCondition);
            }}/>
        </div>
        <div className='flex line alignCenter mgr20 searchBoxItem'>
            备注：
            <Input placeholder='备注' value={searchCondition.remark} onChange={(e) => {
                searchCondition.remark = e.target.value;
                setSearchCondition(searchCondition);
            }}/>
        </div>
        <div className='flex line alignCenter mgr20 searchBoxItem'>
            到货时间：
            <RangePicker locale={locale} value={searchCondition.arrivalDate} onChange={(e, d) => {
                searchCondition.arrivalDate = e ? e : [null, null];
                setSearchCondition(searchCondition);
            }}/>
        </div>

        <div className='flex line alignCenter mgr20 searchBoxItem'>
            截团时间：
            <RangePicker locale={locale} value={searchCondition.endTime} onChange={(e, d) => {
                searchCondition.endTime = e ? e : [null, null];
                setSearchCondition(searchCondition);
            }}/>
        </div>
        <Button className='mgr10 themeBtn' onClick={() => searchCall()} icon={<SearchOutlined/>}>搜索</Button>
        <Button className='mgr10'>重置</Button>
    </div>);
};

const OrderTableProductRender = (props) => {
    const {products} = props;
    const productDescription = products.map((product, index) => {
        return (<div key={index}>{product.name} * {product.num}</div>);
    })
    let productDesc = '';
    const maxShowProduct = 3;
    let i = 0;
    for (const product of products) {
        if (i < maxShowProduct) {
            i++;
            productDesc += (product.name + ',');
        }
    }
    productDesc += '...';
    return (
        <Tooltip
            title={
                <div>
                    <div>{productDescription}</div>
                </div>
            }>
            <div>{productDesc}</div>
        </Tooltip>
    );
}

const OrderItemRemarks = (props) => {
    const {remarks} = props;
    return (<div className="orderRemarks">
        {
            remarks.map((item, index) => {
                return (
                    <div className="orderRemark" key={index}>
                        {item['remark_type'] === 1 && (<Tooltip title={item['remark_detail']}>
                            <p>用户备注</p>
                        </Tooltip>)}
                        {item['remark_type'] === 2 && (<Tooltip title={item['remark_detail']}>
                            <p>团长备注</p>
                        </Tooltip>)}
                        {item['remark_type'] === 3 && (<Tooltip title={item['remark_detail']}>
                            <p>商家备注</p>
                        </Tooltip>)}
                    </div>
                )
            })
        }
    </div>);
};

const OrderItemOperator = (props) => {
    let {order, orderType, showRemarkPopup} = props;
    return (
        <div className='flex flex-warp-warp orderItemOperator'>
            <Link className='mgr10' to={'/order/orderDetail?id=' + order.id}>查看详情</Link>

            {
                orderType === OrderType.CONTRACT_PRODUCT_ORDERS && (order['allow'] ? (
                    <Popconfirm
                        title='确定不允许退款？'
                        onConfirm={() => {
                        }}
                        okText='yes'
                        cancelText='no'
                    >
                        <div className='mgr10 pointer themeColor'>允许退款</div>
                    </Popconfirm>
                ) : (
                    <Popconfirm
                        title='确定允许退款？'
                        onConfirm={() => {
                        }}
                        okText='yes'
                        cancelText='no'
                    >
                        <div className='mgr10 pointer warn'>不允许退款</div>
                    </Popconfirm>
                ))
            }

            <div className='pointer' onClick={() => {
                showRemarkPopup(order);
            }}>备注
            </div>
            {
                order['afterServiceId'] && (
                    <div className='warn pointer' onClick={() => {
                    }}>待退款</div>
                )
            }
        </div>
    )
};

const orderTransformer = (order) => {
    order['gb_name'] = order['gb']['name'];
    order['sale_merchant_name'] = order['provider']['name'];
    order['order_status_desc'] = qs.orderStatus2(order['status']);
    order['order_delivery_type'] = order['delivery'] ? qs.logistics_type(order['delivery']['type']) : '';
    order['user_name'] = order['user']['name'];
    order['user_mobile'] = order['user']['mobile'];
    order['products'] = [];
    if (!isEmpty(order['gb']) && !isEmpty(order['gb']['batches'])) {
        for (let batch of order['gb']['batches']) {
            for (let product of batch['products']) {
                order['products'].push(product);
            }
        }
    }
    return order;
}

const OrderTable = (props) => {
    const columns = [
        {
            title: '订单ID',
            width: 180,
            key: "id",
            fixed: 'left',
            dataIndex: "id",
        },
        {
            title: '团购/合约/商城订单名称',
            width: 180,
            key: "gb_name",
            dataIndex: "gb_name",
        },
        {
            title: '所属商户（团长）',
            width: 140,
            key: "sale_merchant_name",
            dataIndex: "sale_merchant_name",
        },
        {
            title: '用户名',
            width: 100,
            key: "user_name",
            dataIndex: "user_name",
        },
        {
            title: '用户手机号',
            width: 120,
            key: "user_mobile",
            dataIndex: "user_mobile",
        },
        {
            title: '商品信息',
            width: 180,
            render: (ctx) => <OrderTableProductRender products={ctx['products']}/>
        },
        {
            title: '订单金额',
            width: 180,
            key: "order_payment_amount",
            dataIndex: "order_payment_amount",
        },
        {
            title: '物流类型',
            width: 100,
            key: "order_delivery_type",
            dataIndex: "order_delivery_type",
        },
        {
            title: '备注',
            width: 120,
            key: 'id',
            render: (ctx) => <OrderItemRemarks remarks={ctx['remarks']}/>
        },
        {
            title: '下单时间',
            width: 100,
            dataIndex: 'buy_time',
            key: 'buy_time',
        },
        {
            title: '订单状态',
            width: 100,
            key: "order_status_desc",
            dataIndex: "order_status_desc",
        },
        {
            title: '操作',
            width: 124,
            fixed: 'right',
            key: 'id',
            render: (ctx, record, index) => <OrderItemOperator order={ctx} index={index}
                                                               showRemarkPopup={props.showRemarkPopup}/>
        },
    ];
    const {dataSource, pagination, selectOrderIds} = props;
    let pageSources = dataSource[pagination['current']] ? dataSource[pagination['current']] : [];
    const sources = pageSources.map((data) => {
        return orderTransformer(data);
    })
    const scroll = {
        x: 1900
    };
    const rowSelection = {
        onChange: (selectedRowKeys) => {
            selectOrderIds(selectedRowKeys);
        },
    };
    return (
        <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            dataSource={sources}
            columns={columns}
            pagination={pagination}
            scroll={scroll}/>
    );
};

class OrdersList extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            orderType: 0,
            dataSource: {},
            show_refund_param: {},
            showRemark: false,
            showOldExporter: false,
            exportRules: {},
            advancedExporterShow: false,
            searchCondition: {
                contractName: '',
                mchOrUserName: '',
                orderStatus: 0,
                orderId: '',
                arrivalDate: [null, null],
                endTime: [null, null],
                remark: '',
                orderStatusDesc: ''
            },
            page: 1,
            total: 0,
            statisticsData: null,
            afterServiceId: '',
            selectOrder: null,
            selectedOrderIds: [],
        }
    }

    async init () {
        await this.setState({page: 1, dataSource: {}, statisticsData: null});
        await this.loadSaleMerchantInfo();
        await this.getOrders();
    }

    componentDidMount () {
        this.init().then(() => {
        });
    }

    shouldComponentUpdate (nextProps, nextState) {
        if (nextProps.token.value != this.props.token.value) {
            setTimeout(async () => {
                await this.init();
            }, 500);
        }
        return !shallowEqual(nextProps, this.props) || !shallowEqual(nextState, this.state);
    }

    getOrders = async (sql) => {//获取订单列表
        let {orderType, page, dataSource} = this.state;
        if (dataSource[page]) {
            return;
        }
        let param = {
            type: 2,
            page,
            page_size: 15,
            is_back: 1
        }
        param['order_type'] = orderType;
        if (sql) {
            param['search'] = sql.search
        }
        let res = await api('get-orders', param);
        if (res['code'] === 200) {
            let orders = res['data'];
            dataSource[page] = orders;
            let resources = {...dataSource};
            this.setState({
                dataSource: resources,
                total: res['meta']['paginate']['total_count'],
            })
        }
    }
    loadSaleMerchantInfo = async () => {//获取后台首页销售总金额
        let res = await api('sum-order-amount-by-merchant');
        if (res['code'] === 200) {
            this.setState({
                statisticsData: {...res['data']}
            })
        }
    }
    changeOrderType = async (orderType) => {
        await this.setState({
            orderType: orderType,
            page: 1,
            dataSource: {}
        })
        await this.getOrders();
    }

    showRefundHandle = async (data) => {//待退款
        this.setState({
            afterServiceId: data['afterServiceId']
        })
    }

    showRemarkPopup = (order) => {//展示备注
        this.setState({
            showRemark: true,
            selectOrder: order
        });
    }

    showExportHandle = (export_type_s) => {//导出订单
        let exportRules = {
            export_type_s
        }
        let search = this.buildSearchConditionStr();
        exportRules['search'] = search ? search : '';
        this.setState({
            exportRules,
            showOldExporter: true,
        })
    }
    selectedOrderIds = (orderIds) => {
        this.setState({selectedOrderIds: orderIds});
    }
    buildSearchConditionStr = () => {
        let {searchCondition, selectedOrderIds} = this.state;
        searchCondition.orderStatusDesc = OrderStatusOptions[searchCondition.orderStatus].title;
        this.setState({searchCondition: {...searchCondition}});
        let sSearchCondition = [];
        if (searchCondition.orderStatus) {
            sSearchCondition.push({
                name: 'order_status',
                val: OrderStatusOptions[searchCondition.orderStatus].value,
                rule: 'in'
            });
        }
        if (searchCondition.remark) {
            sSearchCondition.push({name: 'remark', val: searchCondition.contractName, rule: 'like'});
        }

        if (searchCondition.contractName) {
            sSearchCondition.push({name: 'gb_name', val: searchCondition.contractName, rule: 'like'});
        }
        if (searchCondition.orderId) {
            sSearchCondition.push({name: 'order_id', val: searchCondition.orderId, rule: 'like'});
        } else if (!isEmpty(selectedOrderIds)) {
            sSearchCondition.push({name: 'order_id', val: selectedOrderIds, rule: 'in'});
        }

        if (searchCondition.mchOrUserName) {
            sSearchCondition.push({name: 'name', val: searchCondition.mchOrUserName, rule: 'like'});
        }

        if (searchCondition.arrivalDate[0] && searchCondition.arrivalDate[1]) {
            let value = [searchCondition.arrivalDate[0].format("YYYY-MM-DD"), searchCondition.arrivalDate[1].clone().add(1, 'days').format("YYYY-MM-DD")];
            sSearchCondition.push({name: 'arrival_date', val: value, rule: 'between'})
        }

        if (searchCondition.endTime[0] && searchCondition.endTime[1]) {
            let value = [searchCondition.endTime[0].format("YYYY-MM-DD"), searchCondition.endTime[1].clone().add(1, 'days').format("YYYY-MM-DD")];
            sSearchCondition.push({name: 'end_time', val: value, rule: 'between'})
        }
        let sql = {
            search: null
        };
        if (!isEmpty(sSearchCondition)) {
            sql = qs.sqlSearch(sSearchCondition);
        }
        if (sql.search) {
            sql.search = Base64.encode(JSON.stringify(sql.search));
        }
        return sql.search;
    }
    searchOrders = async (page = 1) => {
        await this.setState({
            page: page,
            dataSource: {},
        });
        let sql = this.buildSearchConditionStr();
        await this.getOrders({search: sql})
    }
    addExportOrderTask = async (fields, strategies, condition, remark) => {
        let searchCondition = searchConditionConstructor(condition);
        const params = {
            'system': SystemType.MERCHANT_ADMIN,
            'name': '自定义导出（' + (new Date()).toLocaleString() + ')',
            'search_condition': searchCondition,
            'execute_condition': {
                'repeat_grep_days': 0,
            },
            'export_fields': fields,
            'remark': remark
        };

        const event = new AddOnceCustomOrderExportTaskEvent(params);
        await EventDispatcher.dispatch(event);
    }

    render () {
        let {
            orderType, dataSource,
            showRemark, showOldExporter,
            exportRules, page, total,
            statisticsData,
            searchCondition,
            afterServiceId,
            selectOrder,
            advancedExporterShow,
        } = this.state;
        const pagination = {
            current: page,
            total: total,
            pageSize: 15,
            showSizeChanger: false,
            onChange: async (page) => {
                await this.setState({page: page});
                await this.getOrders();
            }
        };
        const setSearchCondition = (searchCondition) => {
            this.setState({searchCondition: {...searchCondition}})
        }
        return (
            <div className='ordersList'>
                {/* 头部 */}
                {statisticsData && <UserInfo rightBox={<HeaderRight statisticsData={statisticsData}/>}/>}
                <div className='record'>
                    <Tabs orderType={orderType} changeOrderType={this.changeOrderType}/>
                    <SearchBox searchCondition={searchCondition} setSearchCondition={setSearchCondition}
                               searchCall={() => this.searchOrders(1)}/>
                    <div className='contentItemWrapper'>
                        <div className='flex alignCenter screen mgb10'>
                            <div className='flex alignCenter'>
                                <Button icon={<ToTopOutlined/>} className='themeBtn' size='' onClick={() => {
                                    this.showExportHandle('single')
                                }}> 导出单次配送单</Button>
                                <Button icon={<ToTopOutlined/>} className='themeBtn' size='' onClick={() => {
                                    this.showExportHandle()
                                }}>批量导出订单</Button>
                                <Button icon={<ToTopOutlined/>} className='themeBtn' size='' onClick={() => {
                                    this.setState({advancedExporterShow: true})
                                }}>订单自定义批量导出（新）</Button>
                            </div>
                        </div>
                        <OrderTable dataSource={dataSource} pagination={pagination}
                                    showRemarkPopup={this.showRemarkPopup} selectOrderIds={this.selectedOrderIds}/>
                    </div>
                </div>

                <Refund afterServiceId={afterServiceId} colsePop={() => this.setState({afterServiceId: 0})}/>
                {
                    showRemark && (
                        <Remark
                            update={async () => {
                                await this.getOrders()
                            }}
                            orderId={selectOrder.id}
                            colsePop={(e) => {
                                showRemark = false
                                this.setState({showRemark})
                            }}/>)
                }

                {
                    showOldExporter && (<PrintPro showSet={(show) => {
                        if (!show) {
                            showOldExporter = false;
                            this.setState({
                                showOldExporter
                            })
                        }
                    }} searchCondition={searchCondition} exportRules={exportRules} jumpUrl={e => {
                        this.props.history.push(e)
                    }} colsePop={() => {
                        showOldExporter = false;
                        this.setState({
                            showOldExporter
                        })
                    }}/>)
                }
                {advancedExporterShow && <CustomDefineExporter searchCondition={searchCondition}
                                                               closePopup={() => this.setState({advancedExporterShow: false})}
                                                               submit={this.addExportOrderTask}/>}
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(OrdersList);